import React from 'react';

export type PageWidth = 'narrow' | 'wide';

interface PageShellProps {
  /** `narrow` suits tools and forms; `wide` suits the request inspector. */
  width?: PageWidth;
  children: React.ReactNode;
  className?: string;
}

/**
 * Owns the page max-width, horizontal gutters and vertical rhythm.
 *
 * Every page is a `PageShell`; no page should write `Container className="py-5"`
 * directly again. The two widths exist so the request inspector can breathe on
 * desktop while the tools stay in a readable measure.
 */
const PageShell: React.FC<PageShellProps> = ({ width = 'narrow', children, className = '' }) => (
  <div className={`page-shell page-shell--${width} ${className}`.trim()}>{children}</div>
);

export default PageShell;
